// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M24.0219 25.2053L6.38525 19.3722C5.3591 19.0365 4.6642 18.0802 4.66187 17.0005V13.6658C4.66535 12.5871 5.36003 11.6322 6.38525 11.2968L24.0219 5.46374C24.7867 5.20708 25.6283 5.33277 26.2847 5.80173C26.9411 6.27069 27.3328 7.02601 27.338 7.83273V22.8363C27.3328 23.643 26.9411 24.3984 26.2847 24.8673C25.6283 25.3363 24.7867 25.462 24.0219 25.2053Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M11.0807 20.9248C10.8103 21.4668 10.6679 22.0638 10.6646 22.6695 10.6787 24.7246 12.2472 26.4349 14.2934 26.6263 16.3397 26.8178 18.1982 25.428 18.5932 23.4112M11.0806 20.9248 18.593 23.4112"
    />
  </svg>
);
const IconSpeaker = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconSpeaker;
